import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { Observable, of } from 'rxjs';
import { ConfirmationService } from '../services/confirmation.service';
import { HasUnsavedChanges } from '../models/api.model';


export const pendingChangesGuard: CanDeactivateFn<HasUnsavedChanges> = (component) => {
    const confirmationService = inject(ConfirmationService);

    if (component.hasUnsavedChanges()) {
        return confirmationService.confirm({
            title: 'Leave page?',
            message: 'Changes you made may not be saved.',
            confirmText: 'Leave',
            cancelText: 'Stay'
        });
    }
    return of(true);
};
